import { useState } from 'react';

export default function LaGomera() {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);

  const images = [
    {
      url: "https://i.imgur.com/Gg2zJut.jpg",
      alt: "La Gomera - Paisaje natural"
    },
    {
      url: "https://i.imgur.com/sPypim3.jpg",
      alt: "La Gomera - Vista panorámica"
    },
    {
      url: "https://i.imgur.com/Q18czdj.jpg",
      alt: "La Gomera - Naturaleza"
    },
    {
      url: "https://i.imgur.com/ZP8XEW1.jpg",
      alt: "La Gomera - Costa"
    },
    {
      url: "https://i.imgur.com/FEpLJBl.jpg",
      alt: "La Gomera - Bosques"
    },
    {
      url: "https://i.imgur.com/UXUBimh.jpg",
      alt: "La Gomera - Montañas"
    },
    {
      url: "https://i.imgur.com/roq6LWm.jpg",
      alt: "La Gomera - Vistas"
    },
    {
      url: "https://i.imgur.com/TDJEFGf.jpg",
      alt: "La Gomera - Paisaje volcánico"
    },
    {
      url: "https://i.imgur.com/gP2SxFk.jpg",
      alt: "La Gomera - Naturaleza única"
    }
  ];

  return (
    <>
      <section id="la-gomera" className="py-32 px-6 bg-gradient-to-br from-teal-50 via-emerald-50 to-green-50 relative overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute top-0 left-0 w-96 h-96 bg-teal-200/20 rounded-full blur-3xl -z-10"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-emerald-200/20 rounded-full blur-3xl -z-10"></div>
        
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-block mb-6">
              <div className="flex items-center gap-3 bg-teal-800 text-white px-6 py-2 rounded-full">
                <i className="ri-earth-line text-2xl"></i>
                <span className="text-sm font-medium uppercase tracking-wider">UNESCO Biosphere Reserve</span>
              </div>
            </div>
            
            <h2 className="text-5xl md:text-6xl font-light text-stone-800 mb-6 leading-tight">
              La Gomera w 60 sekund
            </h2>
            
            <div className="w-32 h-1 bg-gradient-to-r from-transparent via-teal-600 to-transparent mx-auto mb-8"></div>
            
            <p className="text-xl text-stone-600 max-w-3xl mx-auto leading-relaxed">
              Odkryj najautentyczniejszą i najbardziej dziewiczą z Wysp Kanaryjskich. 
              Miejsce, gdzie natura pozostała nietkniętą przez masową turystykę.
            </p>
          </div>

          {/* Photo Gallery - 9 photos in creative layout */}
          <div className="grid grid-cols-12 gap-4 mb-16">
            {/* Large featured image - spans 7 columns, 2 rows */}
            <div 
              className="col-span-12 md:col-span-7 md:row-span-2 relative group overflow-hidden rounded-2xl shadow-2xl cursor-pointer"
              onClick={() => setSelectedImage(0)}
            >
              <div className="w-full h-[500px] md:h-[640px]">
                <img 
                  src={images[0].url}
                  alt={images[0].alt}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-6 left-6 text-white">
                  <i className="ri-zoom-in-line text-3xl"></i>
                </div>
              </div>
            </div>

            {/* Two medium images on the right - 5 columns each, 1 row */}
            {images.slice(1, 3).map((image, index) => (
              <div 
                key={index + 1}
                className="col-span-6 md:col-span-5 relative group overflow-hidden rounded-2xl shadow-xl cursor-pointer"
                onClick={() => setSelectedImage(index + 1)}
              >
                <div className="w-full h-[310px]">
                  <img 
                    src={image.url}
                    alt={image.alt}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-4 left-4 text-white">
                    <i className="ri-zoom-in-line text-2xl"></i>
                  </div>
                </div>
              </div>
            ))}

            {/* Six small images - 4 columns each */}
            {images.slice(3).map((image, index) => (
              <div 
                key={index + 3}
                className="col-span-6 md:col-span-4 relative group overflow-hidden rounded-2xl shadow-xl cursor-pointer"
                onClick={() => setSelectedImage(index + 3)}
              >
                <div className="w-full h-[240px]">
                  <img 
                    src={image.url}
                    alt={image.alt}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-4 left-4 text-white">
                    <i className="ri-zoom-in-line text-2xl"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          {/* Features Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 flex items-center justify-center flex-shrink-0 bg-green-100 rounded-full mb-5">
                <i className="ri-leaf-line text-green-700 text-3xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-stone-800 mb-3">Rezerwat Biosfery UNESCO</h3>
              <p className="text-stone-600 leading-relaxed">
                Dziewicza przyroda, endemiczne lasy laurowe, unikalna flora i fauna chroniona przez UNESCO.
              </p>
            </div>
            
            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 flex items-center justify-center flex-shrink-0 bg-blue-100 rounded-full mb-5">
                <i className="ri-compass-3-line text-blue-700 text-3xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-stone-800 mb-3">Autentyczna Wyspa</h3>
              <p className="text-stone-600 leading-relaxed">
                Najmniej turystyczna z Wysp Kanaryjskich – spokój, cisza i autentyczne doświadczenia z dala od masowej turystyki.
              </p>
            </div>
            
            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 flex items-center justify-center flex-shrink-0 bg-amber-100 rounded-full mb-5">
                <i className="ri-sun-line text-amber-700 text-3xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-stone-800 mb-3">Wieczna Wiosna</h3>
              <p className="text-stone-600 leading-relaxed">
                Łagodny klimat przez cały rok, idealne warunki do relaksu, golfa i aktywności na świeżym powietrzu.
              </p>
            </div>
            
            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 flex items-center justify-center flex-shrink-0 bg-purple-100 rounded-full mb-5">
                <i className="ri-star-line text-purple-700 text-3xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-stone-800 mb-3">Unikalne Doświadczenia</h3>
              <p className="text-stone-600 leading-relaxed">
                Gwizd Silbo Gomero, tradycyjna kuchnia, szlaki trekkingowe i obserwacja gwiazd w krystalicznie czystym niebie.
              </p>
            </div>
          </div>

          {/* Detailed Highlights */}
          <div className="bg-gradient-to-r from-teal-800 to-emerald-700 rounded-2xl p-12 text-white shadow-2xl">
            <h3 className="text-3xl font-light mb-8 text-center">
              Co czyni La Gomerę wyjątkową?
            </h3>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                  <i className="ri-check-line text-2xl"></i>
                </div>
                <div>
                  <h5 className="font-semibold mb-2 text-lg">Lasy Laurowe Garajonay</h5>
                  <p className="text-teal-100 leading-relaxed">
                    Park Narodowy Garajonay z prehistorycznymi lasami laurowymi pokrywającymi 70% wyspy. 
                    Relikt trzeciorzędu, który przetrwał epokę lodowcową.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                  <i className="ri-check-line text-2xl"></i>
                </div>
                <div>
                  <h5 className="font-semibold mb-2 text-lg">Silbo Gomero - Język Gwizdu</h5>
                  <p className="text-teal-100 leading-relaxed">
                    Jedyny gwizdany język na świecie, wpisany na listę UNESCO. 
                    Pasterze komunikowali się przez dolinę za pomocą gwizdów.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                  <i className="ri-check-line text-2xl"></i>
                </div>
                <div>
                  <h5 className="font-semibold mb-2 text-lg">Klify Los Órganos</h5>
                  <p className="text-teal-100 leading-relaxed">
                    Spektakularne bazaltowe formacje skalne przypominające organy katedralne, 
                    powstałe z zastygnięcia lawy wulkanicznej.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                  <i className="ri-check-line text-2xl"></i>
                </div>
                <div>
                  <h5 className="font-semibold mb-2 text-lg">Szlaki Trekkingowe</h5>
                  <p className="text-teal-100 leading-relaxed">
                    Ponad 600 km znakowanych szlaków prowadzących przez lasy, klify, 
                    doliny i wioski – raj dla miłośników aktywnego wypoczynku.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                  <i className="ri-check-line text-2xl"></i>
                </div>
                <div>
                  <h5 className="font-semibold mb-2 text-lg">Gastronomia Lokalna</h5>
                  <p className="text-teal-100 leading-relaxed">
                    Tradycyjne dania: almogrote, miel de palma, gofio. 
                    Autentyczne smaki z lokalnych produktów, bez masowej produkcji.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                  <i className="ri-check-line text-2xl"></i>
                </div>
                <div>
                  <h5 className="font-semibold mb-2 text-lg">Niebo Pełne Gwiazd</h5>
                  <p className="text-teal-100 leading-relaxed">
                    Minimalne zanieczyszczenie świetlne – idealne warunki do obserwacji 
                    nieba nocnego i astrofotografii.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* B2B Selling Point */}
          <div className="mt-16 bg-white rounded-2xl p-10 shadow-xl border-2 border-teal-200">
            <div className="flex items-start gap-6">
              <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                <i className="ri-lightbulb-line text-teal-700 text-3xl"></i>
              </div>
              <div>
                <h4 className="text-2xl font-semibold text-stone-800 mb-4">
                  Dlaczego La Gomera to idealna oferta dla Twoich klientów?
                </h4>
                <div className="space-y-3 text-stone-600 leading-relaxed">
                  <p className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-teal-600 text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Ekskluzywność bez tłumów:</strong> Twoi klienci doświadczą autentycznych Kanarów z dala od masowej turystyki</span>
                  </p>
                  <p className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-teal-600 text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Kombinacja relaksu i przygody:</strong> Od golfa i spa po trekking i obserwację wielorybów</span>
                  </p>
                  <p className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-teal-600 text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Destynacja cały rok:</strong> Idealne warunki pogodowe przez 365 dni – brak sezonowości</span>
                  </p>
                  <p className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-teal-600 text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>UNESCO + Ekologia:</strong> Rosnący segment klientów szukających zrównoważonej turystyki</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage !== null && (
        <div 
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-6"
          onClick={() => setSelectedImage(null)}
        >
          <button 
            className="absolute top-6 right-6 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors cursor-pointer"
            onClick={() => setSelectedImage(null)}
          >
            <i className="ri-close-line text-3xl"></i>
          </button>
          
          <div className="max-w-6xl w-full">
            <img 
              src={images[selectedImage].url}
              alt={images[selectedImage].alt}
              className="w-full h-auto rounded-lg shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            />
          </div>

          {/* Navigation arrows */}
          {selectedImage > 0 && (
            <button
              className="absolute left-6 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedImage(selectedImage - 1);
              }}
            >
              <i className="ri-arrow-left-line text-2xl"></i>
            </button>
          )}
          
          {selectedImage < images.length - 1 && (
            <button
              className="absolute right-6 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedImage(selectedImage + 1);
              }}
            >
              <i className="ri-arrow-right-line text-2xl"></i>
            </button>
          )}
        </div>
      )}
    </>
  );
}
